<template>
    <v-btn @click="paste" color="primary" small :loading="loading">
        <v-icon left>
            mdi-content-paste
        </v-icon>
        paste
    </v-btn>
</template>

<script>
export default {
    data: () => ({
        loading: false,
    }),

    methods: {
        async paste() {
            this.loading = true
            const questionIds = (await navigator.clipboard.readText()).split(',')
            const response = await this.$apiv2.get('question-import/questions', {
                params: {
                    questionIds: questionIds
                }
            })
            const questions = response.data.questions

            const result = []
            for (const questionId of questionIds) {
                result.push(questions.find(question => question.id == questionId))
            }

            this.loading = false

            this.$emit('paste', result);
        }
    }
}
</script>
